var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPgxBrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17.509611 20.495539",
    id: "svg21",
    width: 17.5,
    height: 20.5,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style1"
  }, "\n      .pgx-brain {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g21",
    transform: "translate(-36.500024,-3.7544604)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "pgx-brain",
    d: "M 43.72,23.5 V 20.88 C 43.63,20.06 43.3,19.42 42.53,19.35 l -2.25,-0.21 c -0.65,-0.06 -1.17,-0.62 -1.22,-1.31 l -0.13,-2.84 -1.68,-0.63 1.58,-3.85 -0.05,-0.11 c 0.04,-3.23 2.51,-5.83 5.55,-5.84 0,0 2.09,-0.19 4.18,0.14 2.32,0.37 4.48,2.5 4.72,4.91 0.14,1.43 -0.26,2.99 -0.67,4.14 l -1.61,3.31 c -0.01,0.07 -0.03,0.15 -0.04,0.24 -0.15,1.04 0,2.09 0.34,3.08 l 1.06,3.01 -8.57,0.11 z",
    id: "path2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pgx-brain",
    d: "m 48.39,15.46 c -0.15,-0.23 -0.66,-0.27 -0.81,-0.5 -0.07,-0.07 -0.15,-0.17 -0.22,-0.31 -0.16,-0.34 -0.09,-0.67 -0.05,-0.78 -0.08,0.02 -0.5,0.15 -0.94,-0.08 -0.36,-0.19 -0.5,-0.5 -0.54,-0.59 0,-0.25 -0.17,-0.21 -0.17,-0.45 -0.05,0.04 -0.76,0.43 -1.79,0.07 -0.78,-0.27 -1.09,-0.95 -1.14,-1.08 -0.05,0 -0.94,-0.18 -1.25,-0.99 C 41.27,10.21 41.46,9.73 41.51,9.61 41.54,9.44 41.62,9.03 41.98,8.72 42.22,8.51 42.49,8.45 42.72,8.4 43.13,8.31 43.47,8.33 43.7,8.37 43.55,7.95 43.64,7.49 43.94,7.21 c 0.38,-0.37 1.06,-0.4 1.55,0 0.02,-0.03 0.26,-0.45 0.74,-0.48 0.38,-0.02 0.74,0.21 0.9,0.57 0.46,-0.16 0.97,-0.06 1.33,0.27 0.53,0.49 0.37,1.19 0.37,1.22 0.25,-0.23 0.59,-0.27 0.81,-0.12 0.19,0.13 0.23,0.36 0.23,0.41 0.16,0.09 0.34,0.22 0.37,0.42 0.06,0.33 -0.33,0.53 -0.3,0.86 0.01,0.15 0.12,0.36 0.51,0.58 0.04,0.11 0.13,0.4 0.03,0.75 -0.15,0.5 -0.58,0.72 -0.65,0.76 l -0.62,0.08 c -0.51,0.53 -0.08,0.63 0.13,1.16 0.05,0.12 0.13,0.32 0.34,0.5",
    id: "path3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pgx-brain",
    d: "m 45.11,10.72 c 0,0 0.54,0.15 0.95,-0.2 0.4,-0.35 0.32,-0.85 0.32,-0.88",
    id: "path4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPgxBrain);
export default __webpack_public_path__ + "static/media/PGXBrain.e82973ae89f5fcc51c6840c080473502.svg";
export { ForwardRef as ReactComponent };